import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { StakingcompletePage } from './stakingcomplete';

@NgModule({
  declarations: [
    StakingcompletePage,
  ],
  imports: [
    IonicPageModule.forChild(StakingcompletePage),
  ],
})
export class StakingcompletePageModule {}



// WEBPACK FOOTER //
// ./src/pages/stakingcomplete/stakingcomplete.module.ts